module.exports = __webpack_public_path__ + "static/media/SPAIN.a62a83f3.svg";